export const ZERO_ADDRESS = "0x0000000000000000000000000000000000000000";

// When ETK has no cooler it is a ZERO_ADDRESS
export const hasCooler = (coolerAddress: unknown): boolean => {
  if (!coolerAddress) return false;
  if (typeof coolerAddress !== "string") return false;
  return coolerAddress !== ZERO_ADDRESS;
};
